/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/InternalModelsAPI'
], (APIFactory, InternalModelsAPI) => {

	/**
	 * @implements InternalModelsAPI
	 */
	class InternalModels {

		constructor({ widgetModel, layoutModel }) {
			this.widgetModel = widgetModel;
			this.layoutModel = layoutModel;
			this._api = APIFactory.createAPI(this, [InternalModelsAPI]);
		}

		getAPI () {
			return this._api;
		}

		getWidgetModel() {
			return this.widgetModel;
		}

		getLayoutModel() {
			return this.layoutModel;
		}

		toJSON() {
			if (this.widgetModel) {
				return this.widgetModel.toJSON();
			}
		}

	}

	return InternalModels;
});
